import { TmcContextService } from './../../../../common/tmc-context.service';
import { RegistrationStepperModel } from './../../model/registration-step-model';
import { TransportRegistration } from './../../model/transport-registration';
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';

import { AsyncSubject, Subscription } from 'rxjs';
import { AppClientConfigurationService } from '@sdbn/common';
import { TransportOption, TransportOptionColumn, TransportOptionsPanelModel } from '../../../../components/transport-options-panel/transport-options-panel.model';
import { YardConfiguration } from '../../../../client/model/yard-configuration';

@Component({
  selector: 'app-transport-options',
  templateUrl: './transport-options.component.html',
  styleUrls: ['./transport-options.component.scss'],
  standalone: false
})
export class TransportOptionsComponent implements OnInit, AfterViewInit {

  private stepCompleted = false;
  _registration: TransportRegistration;

  model: TransportOptionsPanelModel;
  validStateSubscription: Subscription;
  selectionChangeSubscription: Subscription;

  tmcContextSubscription: Subscription;
  yardConfiguration: YardConfiguration;

  @Input() set registration(registration: TransportRegistration) {
    this._registration = registration;
    this.createTransportOptionsModel();
  }

  @Input() stepperModel: RegistrationStepperModel;

  constructor(
    public cps: AppClientConfigurationService,
    private tmcContextService: TmcContextService
  ) { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.stepperModel.stepCompleted = () => {
      return this.stepCompleted;
    };

    this.stepperModel.beforeShowNextStep = () => {
      const subject = new AsyncSubject<boolean>();
      subject.next(true);
      subject.complete();
      return subject;
    };
  }

  createTransportOptionsModel() {

    if (this.validStateSubscription != null) {
      this.validStateSubscription.unsubscribe();
    }
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
    }

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        this.yardConfiguration = next;
        let columns = new Array<TransportOptionColumn>();
        for (let option of this.yardConfiguration.transportOptions) {
          while (option.columnIndex != null && columns.length < option.columnIndex + 1) {
            let column = new TransportOptionColumn();
            columns.push(column);
          }
          let column = columns[option.columnIndex];
          console.log('processing transport option', option);
          column.options.push(new TransportOption(option));
        }

        this.model = new TransportOptionsPanelModel({ columns: columns, constraints: this.yardConfiguration.transportOptionConstraints, selection: this._registration.selectedOptions, loadingEnabled: true, parametersEnabled: true });
        this.validStateSubscription = this.model.validState.subscribe(bool => {
          this.stepCompleted = bool;
        });

        this.selectionChangeSubscription = this.model.selectionChange.subscribe(() => {
          this._registration.selectedOptions = this.model.getOnlySelectedTransportOptionSelection();
        });
      }
    });
  }

}
